/**
 * RESPONSIBILITY: the core tenets band on the About page.
 *
 * Cards rather than a list, and each one links onward, because the requirements doc asks
 * for the three tenets to take somebody to the ministry that carries them.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { Card } from '../leadership/rows/card';

@Section({ name: SectionName.AboutTenets, label: 'About · Core tenets' })
export class AboutTenetsSection {
  @Text({ label: 'Title', maxLength: 300, default: 'Our core tenets' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 2 })
  intro!: string;

  @List({
    label: 'Tenets', of: () => Card, maxItems: 6,
    description: 'Each card links to the ministry that carries it.',
  })
  tenets!: Card[];

  @Text({
    label: 'Subtitle', maxLength: 120, default: 'Founding pillars',
    description: 'The small line above the title.',
  })
  eyebrow!: string;

  @Text({
    label: 'Words on each card’s link', maxLength: 120, default: 'Explore ministry',
    description: 'The same on every card, because they all lead to the same kind of page.',
  })
  cardLinkLabel!: string;

  @Text({
    label: 'Strip name', maxLength: 120, default: 'Core tenets', group: 'The strip',
    description: 'Names the row of cards for a screen reader.',
  })
  stripLabel!: string;

  @Text({ label: 'Back arrow', maxLength: 120, default: 'Previous tenets', group: 'The strip' })
  prevLabel!: string;

  @Text({ label: 'Forward arrow', maxLength: 120, default: 'More tenets', group: 'The strip' })
  nextLabel!: string;

  @Text({ label: 'Dots', maxLength: 120, default: 'Tenet', group: 'The strip',
          description: 'Each dot is read as "Tenet 2".' })
  dotsLabel!: string;
}
